import React, {useState} from "react";
import { Helmet } from "react-helmet";
import {Header, Titulo,ContenedorBotones} from './../elementos/Header';
import BtnRegresar from "../elementos/BtnRegresar";
import FormularioViaje from "./FormularioCreaViaje";
import FormularioEditaPasajero from "./FormularioEditaPasajero";
import {ContenedorDoble} from '../elementos/ElementosDeFormularioCreaViaje';
import {Lista, ElementoLista, Descripcion,  BotonAccion, ContenedorSubtitulo, Subtitulo} from './../elementos/ElementosConductores';
import useObtenerPasajeros from './../hooks/useObtenerPasajeros';

const  Pasajeros = () => {
    const [Idp, CambiarIdp] = useState('');
    const [itinerario, cambiarItinerario] = useState([]); 
    const [listadoPasajeros, cambiarListadoPasajeros] = useState([]); 
    const [fechahoraviaje, cambiarFechahoraviaje] = useState ('Ingrese Fecha y hora de Viaje');
    const [cliente, cambiarCliente] = useState ('Seleccione Cliente');
    const viaje = useState([]);
    const pasajeros = useObtenerPasajeros();
    return ( 
        <>
        <Helmet>
        <title> Pasajeros  </title>
        </Helmet>
  
            <Header>
                <BtnRegresar></BtnRegresar>
                <Titulo>Datos de Pasajero</Titulo>         
            </Header>
            
            <ContenedorDoble>
            <FormularioEditaPasajero
                Idp = {Idp}
                CambiarIdp = {CambiarIdp}
                listadoPasajeros={listadoPasajeros} 
                cambiarListadoPasajeros={cambiarListadoPasajeros} 
             >
             </FormularioEditaPasajero>
          {

        <Lista>
        <ContenedorSubtitulo><Subtitulo>Listado de Aprobaciones</Subtitulo></ContenedorSubtitulo>
          {pasajeros.map((pasajero,index) => {
               
               return(
               <div key={pasajero.id}>
                
                <ElementoLista key={pasajero.id}>

                    <Descripcion>&nbsp;{pasajero.telefono}&nbsp;&nbsp;</Descripcion>
                    <Descripcion>&nbsp;{pasajero.nombre}&nbsp;&nbsp;</Descripcion>
                    <Descripcion>&nbsp;{pasajero.estado}&nbsp;&nbsp;</Descripcion>
                    
                    
                    
                    <ContenedorBotones>
                     <BotonAccion onClick={(e) => {
                                                e.preventDefault()
                                               /* EditarConductor(conductor)*/}}>
                        
                      </BotonAccion>
                    </ContenedorBotones>

                </ElementoLista>
                
                </div>)
          
          })}

            </Lista> 



            } 

            </ContenedorDoble>
        
            

        
 
        </>
     );
}
 
export default  Pasajeros;
